import React, { useEffect, useMemo, useRef, useState } from 'react'


export const TemplateOutput = (props) => {

    const output = props.output;

    const changeOutput = (opt) => {
        props.handleChange(opt)
    }

    return (
        <>
            <div className="template-output-box">
                <div style={{ borderRight: "1.5px solid #cfcaca" }}>
                    Output file
                </div>
                <div>
                    <label className="custom-radio">
                        <input type="radio" name="option" checked={output === 'PDF'}
                            onClick={(e) => {
                                changeOutput('PDF');
                            }} />
                        <span className="radio-mark"></span> PDF
                    </label>
                </div>
                <div>
                    <label className="custom-radio">
                        <input type="radio" name="option" checked={output === 'HTML'}
                            onClick={(e) => {
                                changeOutput('HTML');
                            }} />
                        <span className="radio-mark"></span> Html
                    </label>
                </div>
                <div>
                    <label className="custom-radio">
                        <input type="radio" name="option" checked={output === 'EXCEL'}
                            onClick={(e) => {
                                changeOutput('EXCEL');
                            }} />
                        <span className="radio-mark"></span> Excel
                    </label>
                </div>
                <div>
                    <label className="custom-radio">
                        <input type="radio" name="option" checked={output === 'WORD'}
                            onClick={(e) => {
                                changeOutput('WORD');
                            }} />
                        <span className="radio-mark"></span> Word
                    </label>
                </div>
            </div>
        </>
    )
}

export default TemplateOutput;